// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3c-OK","title":"BackImages_title__fKUT1","images":"BackImages_images__27RR3"};